module.exports = new __parcel__URL__("LiveDocsIntroGif.d2fc0787.gif").toString();